import Http from '../http';

class AutoBidMatrixService {
  static async getAllAutoBidMatrices() {
    return Http.get('/autoMatrix');
  }

  static async getAutoBidMatrixById(id) {
    return Http.get(`/autoMatrix/${id}`);
  }

  static async addAutoBidMatrix(data) {
    console.log("Adding Auto Bid Matrix:", data);
    return Http.post('/autoMatrix', data);
  }

  static async updateAutoBidMatrix(id, data) {
    console.log("Updating Auto Bid Matrix:", data);
    return Http.update(`/autoMatrix/${id}`, data);
  }

  static async deleteAutoBidMatrix(id) {
    return Http.delete(`/autoMatrix/${id}`);
  }
}

export default AutoBidMatrixService;
